import styled from 'styled-components'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const BoxCountDown = styled.div`
  margin-top: 22px;
  text-align: center;
`

export const BackButton = styled(Button)`
  font-size: 14px;

  --color: ${myPalette.mutedText.main};
`
